import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getTodoList, getTodoListWithoutDelay } from 'features/todolist/store/actions'
import { toggleCompleteTaskRequest } from 'features/task/store/actions'
import { get as getNotifications } from 'features/notifications/store/actions'
import { openPanel } from 'features/taskPanel/store/actions'
import { markTaskAsRead } from 'features/notifications/store/actions'
import { getCurrentPathName } from 'utils/location'
import { updateTask, patchTaskRequest } from 'features/task/store/actions'
import { findById } from 'features/list/utils'

import { constants, utils } from 'gipsy-misc'

const mapStateToProps = state => ({
  todayList: state.todolist.items.today.list,
  isTodolistLoaded: state.todolist.isTodolistLoaded
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getTodoList,
      getTodoListWithoutDelay,
      toggleCompleteTaskRequest,
      markTaskAsRead,
      openPanel,
      getNotifications,
      updateTask,
      patchTaskRequest,
      findById
    },
    dispatch
  )
})

export default function wrapper(Component) {
  class FocusViewContainer extends PureComponent {
    constructor(props) {
      super(props)

      this.props.actions.getTodoListWithoutDelay()
    }

    componentDidMount() {
      this.startIntervals()
    }

    componentWillUnmount() {
      this.clearIntervals()
    }

    startIntervals = () => {
      this.intervalRefresh = setInterval(this.refreshList, 60 * 1000)
    }

    clearIntervals = () => {
      clearInterval(this.intervalRefresh)
      this.intervalRefresh = undefined
    }

    refreshList = async () => {
      // refresh notifications first to avoid flashing unnotified->notified tasks
      await this.props.actions.getNotifications()
      await this.props.actions.getTodoList()
    }

    onComplete = ({ id, paramName, value }) => {
      this.props.actions.toggleCompleteTaskRequest(id, value, { pageSource: getCurrentPathName() })
    }

    onClick = async (todoItemId, type) => {
      if (type !== 'task') {
        return
      }
      await this.props.actions.openPanel(todoItemId)
      await this.props.actions.markTaskAsRead(todoItemId)
    }

    patchers = {}

    onChange = (taskId, { paramName, value, method = 'change' }) => {
      let task = this.props.actions.findById(taskId)

      const { params, body } = utils.task.computePatchRequest(task, { paramName, value, method })

      let newTask = utils.task.computeTaskOnChange(task, {
        paramName: paramName,
        value: value,
        method: method
      })
      this.props.actions.updateTask(newTask)
      if (!this.patchers[taskId]) {
        this.patchers[taskId] = new utils.TaskPatcher(constants.delayBeforePatch.default)
      }
      return new Promise((resolve, reject) => {
        this.patchers[taskId].put(paramName, method, () => {
          return this.props.actions
            .patchTaskRequest(task.id, params, body)
            .then(args => {
              resolve(args)
              const activeTeamMember = this.props.activeTeamMember
              if (activeTeamMember) {
                this.props.actions.getTodoList()
              }
            })
            .catch(reject)
        })
      })
    }

    render() {
      return this.props.isTodolistLoaded ? (
        <Component
          todayList={this.props.todayList}
          onComplete={this.onComplete}
          onClick={this.onClick}
          onChange={this.onChange}
        />
      ) : null
    }
  }

  const containerRedux = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(FocusViewContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/focusview/container.js